module.exports = __webpack_public_path__ + "img/chevron-bottom.de9a5df8.svg";